import { CloseIcon } from 'assets'
import React, { FC } from 'react'

type PopupModalProps = {
    closeModal?: () => void
    children?: React.ReactNode
    showBg?: boolean
    showCloseIconBtn?: boolean
}

export const PopupModal: FC<PopupModalProps> = ({
    closeModal,
    children,
    showBg,
    showCloseIconBtn = true
}) => {
    return (
        <div className="modal--parent">
            <div
                className={`modal--body-feedback ${showBg ? 'modal-bg' : ''}`}
                data-testid="success-modal"
            >
                {showCloseIconBtn && (
                    <div
                        className="modal--close-icon"
                        onClick={closeModal}
                        data-testid="modal-close-btn"
                        aria-label="modal-close-button"
                    >
                        <CloseIcon />
                    </div>
                )}
                <div className="modal--body-container">{children}</div>
            </div>
        </div>
    )
}
